var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode === 'fight')?_c('FightReport',{attrs:{"fight":_vm.fight,"trainer":_vm.trainer,"position":_vm.position,"is-trainer-fight":_vm.isTrainerFight ? _vm.position.trainerFight : null}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }